import {FormSubmitHandler, showNotification} from 'platform/components';

import {
  useGetMercedesNaSkladePlatformQuery,
  useMercedesNaSkladeAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  MercedesNaSkladeAuthenticationFormData,
  PlatformAuthenticationFormMercedesNaSklade,
} from './PlatformAuthenticationFormMercedesNaSklade';
import {PlatformPhotoSettings} from './PlatformPhotoSettings';

export function PlatformSettingsMercedesNaSklade() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetMercedesNaSkladePlatformQuery({params});
  const [saveAuthentication] = useMercedesNaSkladeAuthenticateMutation();

  const onSubmitCredentials: FormSubmitHandler<MercedesNaSkladeAuthenticationFormData> = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <>
      <PlatformAuthenticationFormMercedesNaSklade
        platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE}
        values={data?.credentials}
        isFetching={isFetching}
        isError={isError}
        onSubmit={onSubmitCredentials}
      />
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE} />
    </>
  );
}
